import type { ReactNode } from 'react';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider as DefaultPersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import { environment } from '../../environment';

import { createIDBPersister } from './utils/create-idb-persister.util';
import { PersistGate } from './PersistGate';

export const QUERY_META_DEHYDRATE = 'dehydrate';
export const PERSISTER_BUSTER = 'persisterBuster';

const persister = createIDBPersister();
const queryClient = new QueryClient();

interface Props {
  readonly children: ReactNode;
}

export const PersistQueryClientProvider = ({ children }: Readonly<Props>) => (
  <DefaultPersistQueryClientProvider
    client={queryClient}
    persistOptions={{
      persister,
      dehydrateOptions: {
        shouldDehydrateQuery: (query) =>
          !!query.meta?.[QUERY_META_DEHYDRATE] &&
          query.state.status === 'success',
      },
      maxAge: environment.persisterMaxAge,
    }}
  >
    <PersistGate>{children}</PersistGate>
  </DefaultPersistQueryClientProvider>
);
